export default "__VITE_ASSET__BuyJi6M7__"